import { ThemeService } from '@/taskpane/services/ThemeService';
import { createRoot } from 'react-dom/client';

import '../tailwind.css';

import { LandingPage } from './LandingPage';

ThemeService.applyTheme();

const container = document.querySelector('#landing-root');
if (container) {
  createRoot(container).render(<LandingPage />);
}
